<div class = "icon-content">
    <div class = "icon-image">
      <img alt="" src = '../../../../assets/images/icon1.png'/>
    </div>
    <div class = "icon-title">{{iconItem.name}}</div>
</div>
